import React from 'react';

const NotificationTransactionEnded = ({ size = 20 }) => {
  return (
    <svg t="1600986142787" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22192" width={size} height={size}>
      <path
        d="M941.967463 109.714286v804.571428q0 14.857143-10.857143 25.714286t-25.714286 10.857143H100.824606q-14.857143 0-25.714286-10.857143t-10.857143-25.714286V109.714286q0-14.857143 10.857143-25.714286t25.714286-10.857143h804.571428q14.857143 0 25.714286 10.857143t10.857143 25.714286z"
        p-id="22193"
        fill="#FC272A"
       />
    </svg>
  );
};

export default NotificationTransactionEnded;
